import { render, staticRenderFns } from "./FinalQuiz.vue?vue&type=template&id=70f73a6a&"
import script from "./FinalQuiz.vue?vue&type=script&lang=js&"
export * from "./FinalQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../aristotle-website/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports